export const PanelDT = {
	panel: {
		css: ({ dt }) => `
              .p-panel-clear {
                border-color: transparent;
                .p-panel-header {
                    background: ${dt('content.background')};
                    border-color: transparent;
                }
                .p-panel-header,
                .p-panel-footer {
                    padding: 0;
                }
                .p-panel-content {
                    padding: var(--p-spacing-s) 0 var(--p-spacing-sm) 0;
                }
              }

              .p-panel-compact-header {
                .p-panel-header {
                  .p-panel-icons {
                      margin-left: var(--p-spacing-xs);
                  }
                }
              }

              .p-panel-no-content-padding {
                .p-panel-content {
                    padding: 0;
                }
              }

              .p-panel-hovered {
                .p-panel-header:hover {
                    cursor: pointer;
                }
              }
        `,
	},
};
